export const background = {
    default: "bg-gray-300 text-gray-800",
    published: "bg-green-600 text-white",
    pending: "bg-blue-500 text-white",
    draft: "bg-gray-300 text-gray-800",
};
export const text = {
    default: "text-gray-900",
    published: "text-green-600",
    pending: "text-blue-500",
    draft: "text-gray-300",
};
